import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import { CardHeader } from "@mui/material";
import AccountingApi from "../../../Classes/API/AccountingApi";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import AddManyToManyReq from "../../../Classes/Models/Requests/AddManyToManyReq";
import CreateDomesticExtraReq from "../../../Classes/Models/Requests/Accounting/CreateDomesticExtraReq";
import { SettingsApplicationsRounded } from "@mui/icons-material";
const AddExtraToStay = ({ Stay, setShowAddExtra, setIsLoaded }) => {
  const [ExtraQuantity, setExtraQuantity] = useState(1);
  const [ExtraType, setExtraType] = useState("");
  const [ExtraDescription, setExtraDescription] = useState("");
  const [ExtraPrice, setExtraPrice] = useState(0);
  const [ExtraQuantityRecieved, setExtraQuantityRecieved] = useState(0);

  const AddExtra = async () => {
    if (ExtraType == "") {
      Swal.fire({
        title: "Error",
        text: "Please select an extra type",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    if (ExtraDescription == "") {
      Swal.fire({
        title: "Error",
        text: "Please enter a description",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    if (ExtraPrice == 0) {
      Swal.fire({
        title: "Error",
        text: "Please enter a price",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    if (ExtraQuantity == 0) {
      Swal.fire({
        title: "Error",
        text: "Please enter a quantity",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    let req = new CreateDomesticExtraReq();
    req.DomesticStayId = Stay.id;
    req.PatientId = Stay.getPatient.id;
    req.ExtraType = ExtraType;
    req.ExtraDescription = ExtraDescription;
    req.ExtraPrice = ExtraPrice;
    req.ExtraQuantity = ExtraQuantity;
    req.QuantityRecieved = ExtraQuantityRecieved;

    let res = await AccountingApi.AddExtraToDomesticStay(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Extra added to stay",
        icon: "success",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
    }
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em", padding: "1em" }}>
      <MDBox mb={2} pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          Add Extra to Stay
        </MDTypography>
        <div>
          <MDButton sx={{ margin: "10px" }} color={"success"} onClick={() => AddExtra()}>
            Add Extra
          </MDButton>

          <MDButton mr={2} color={"info"} onClick={() => setShowAddExtra(false)}>
            Cancel
          </MDButton>
        </div>
      </MDBox>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <MDInput
              sx={{ marginBottom: "1em", width: "100%" }}
              type="text"
              defaultValue={ExtraType}
              onChange={(e) => setExtraType(e.target.value)}
              label="Extra Type"
              name="ExtraType"
              id="ExtraType"
            />
          </div>
          <div className="col-md-3">
            <MDInput
              sx={{ marginBottom: "1em", width: "100%" }}
              type="text"
              defaultValue={ExtraDescription}
              onChange={(e) => setExtraDescription(e.target.value)}
              label="Extra Description"
              name="ExtraDescription"
              id="ExtraDescription"
            />
          </div>
          <div className="col-md-3">
            <MDInput
              sx={{ marginBottom: "1em", width: "100%" }}
              type="number"
              defaultValue={ExtraPrice}
              onChange={(e) => setExtraPrice(e.target.value)}
              label="Extra Price"
              name="ExtraPrice"
              id="ExtraPrice"
            />
          </div>
          <div className="col-md-3">
            <MDInput
              sx={{ marginBottom: "1em", width: "100%" }}
              type="number"
              defaultValue={ExtraQuantity}
              onChange={(e) => setExtraQuantity(e.target.value)}
              label="Extra Quantity"
              name="ExtraQuantity"
              id="ExtraQuantity"
            />
          </div>
          <div className="col-md-3">
            <MDInput
              sx={{ marginBottom: "1em", width: "100%" }}
              type="number"
              defaultValue={ExtraQuantityRecieved}
              onChange={(e) => setExtraQuantityRecieved(e.target.value)}
              label="Extra Quantity Received"
              name="ExtraQuantityRecieved"
              id="ExtraQuantityRecieved"
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AddExtraToStay;
